import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { clearLoginError, login, loginAndJoinToCourse, useSelectLoginError } from 'Auth/data';
import { useAppDispatch } from 'Store';

import type { ILogInAndJoinToCourseRequest, ILogInRequest } from '@libs/models';

import { LoginForm } from './LoginForm';

type Props = {
  joinCode?: string;
  onEmailChange: (email: string) => void;
};

export const LoginFormContainer = ({ joinCode, onEmailChange }: Readonly<Props>) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loginError = useSelectLoginError();

  const handleSubmit = async (values: ILogInRequest) => {
    const result = await (
      joinCode
        ? dispatch(loginAndJoinToCourse({ ...values, joinCode } as ILogInAndJoinToCourseRequest))
        : dispatch(login(values))
    ).unwrap();

    if (result.shouldNavigateTo) {
      navigate(result.shouldNavigateTo, { state: result.navigationState });
    }
  };

  useEffect(() => {
    dispatch(clearLoginError());
  }, [dispatch]);

  return (
    <LoginForm
      onSubmit={handleSubmit}
      error={loginError as string | null}
      onEmailChange={onEmailChange}
    />
  );
};
